import React, { useCallback, useState } from 'react'
import { MemecoinComment } from '../../../../types/reducerTypes'
import styled from 'styled-components'
import { Box } from '../../../../shared_components/UI/Box'
import { useCreateMemecoinReplyMutation } from '../../../../modules/memecoins/api'
import EmbeddableModal from '../../../../shared_components/EmbeddableModal'
import { selectAccount } from '../../../../modules/web3/selectors'
import useWeb3 from '../../../../hooks/useWeb3'
import { ThemedButton } from '../../../../shared_components/ThemedButton'
import { CommentContButton } from './AddComment'
import { useDispatch, useSelector } from 'react-redux'
import { appendMemecoinCommentReply } from '../../../../modules/memecoins/slice'

export const Button = styled.button`
  border-radius: 50px;
  background: var(--surface-brand, #ff5740);
  width: 98%;
  color: var(--Midnight, var(--text-invert, #04111b));
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.18px;
  padding: 8px;
  height: 43px;
`

export const Button2 = styled.button`
  border-radius: 50px;
  background: var(--surface-brand, #161c20);
  width: 98%;
  color: var(--Midnight, var(--text-invert, #fffff));
  text-align: center;
  font-feature-settings: 'ss01' on;
  font-family: 'Space Grotesk';
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.18px;
  padding: 8px;
  height: 43px;
`

const TextArea = styled.textarea`
  width: 100%;
  display: flex;
  outline: none;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;

  border-radius: var(--units-12, 12px);
  border: var(--units-1, 1px) solid var(--stroke-primary, #fff);
  background: var(--surface-minimal-primary, rgba(255, 255, 255, 0.06));

  min-height: 154px;
  padding: var(--Spacing-Padding-M, 16px);
  gap: 18px;
  resize: none;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    font-size: 16px;
    width: 100%;
  }
`

export const Title = styled.h4`
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
`

const Container = styled(Box)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  flex-shrink: 0;
  align-self: stretch;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.sm}px) {
    width: 100%;
  }
`

function AddReplyModal({
  comment,
  isOpen,
  onClose,
}: {
  comment: MemecoinComment
  isOpen: boolean
  onClose: () => void
}) {
  const [createReply] = useCreateMemecoinReplyMutation()
  const [content, setContent] = useState('')
  const [isCreating, setIsCreating] = useState(false)
  const account = useSelector(selectAccount)
  const isConnected = !!account
  const { initWeb3 } = useWeb3()
  const dispatch = useDispatch()

  const handleChangeContent = (e) => {
    setContent(e.target.value)
  }

  const onReply = useCallback(async () => {
    try {
      if (!isConnected) {
        initWeb3()
        return
      }

      if (!content.length) return

      setIsCreating(true)
      const { reply } = await createReply({
        data: {
          content: content.trim(),
          commentId: comment._id,
        },
      }).unwrap()

      dispatch(appendMemecoinCommentReply({
        replies: [
          ...comment.replies,
          { ...reply, reactions: [] }
        ],
        commentId: comment._id
      }))

      setIsCreating(false)
      onClose()
    } catch (error) {
      console.error(error)
    } finally {
      setIsCreating(false)
      setContent('')
    }
  }, [content, createReply, isConnected, initWeb3])

  const isDisabled = (isCreating || !content.length) && isConnected

  if (!isOpen) return null
  
  return (
    <Container>
      <TextArea
        placeholder="Leave a comment"
        value={content}
        onChange={handleChangeContent}
      />
      <CommentContButton jfe>
        <ThemedButton
          $styleType={isDisabled ? 'tertiary' : 'primary'}
          disabled={isDisabled}
          onClick={onReply}
        >
          {!isConnected
            ? 'Connect'
            : isCreating
            ? 'Replying...'
            : 'Reply'}
        </ThemedButton>
      </CommentContButton>
    </Container>
  )
}

export default AddReplyModal
